import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Montserrat } from 'styles/common-fonts';

export const SubtitleMediumStyled = styled(Typography)<TypographyProps>(() => ({
  fontFamily: Montserrat,
  fontWeight: 400,
  fontSize: '0.875rem',
}));

export const SubtitleMediumBoldStyled = styled(Typography)<TypographyProps>(() => ({
  fontFamily: Montserrat,
  fontWeight: 700,
  fontSize: '0.75rem',
}));
